export const MOE_SIDEBAR = "AEH_AUTH_SIDEBAR";

export const NOT_PERSIST_PARTYID_MENU = [];
